<app-dialog-base [showLoadingSpinner]="uiState === uiStateEnumForTemplate.ShowLoading">
  <span dialog-title>Edit Notification Settings</span>

  <ng-container dialog-content>
    <form [formGroup]="notificationSettingsForm">
      <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
        <mat-label>Draw Notifications Start Time</mat-label>
        <input matInput data-testid="notification-start-time-input"
               placeholder="Enter time notifications should start"
               formControlName="notificationsBeginTime">
        <mat-hint>On draw day, the draw reminder email goes out to players who have not entered this draw yet, starting at the first hourly check after this time, so start and end must be at least an hour apart. It does not affect winner results or manual notifications. 24-hour time (14:00 = 2pm, 07:00 = 7am).</mat-hint>
        <mat-error data-testid="notification-start-time-error"
                   *ngIf="(notificationsBeginTimeControl.dirty || notificationsBeginTimeControl.touched) && notificationsBeginTimeControl.errors">
          Required format: HH:MM (24-hour time)
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width margin-top-large" subscriptSizing="dynamic">
        <mat-label>Draw Notifications End Time</mat-label>
        <input matInput data-testid="notification-end-time-input"
               placeholder="Enter time notifications should end"
               formControlName="notificationsEndTime">
        <mat-hint>Every reminder batch must be sent before this time, counting from the hourly check that starts sending. If they cannot all fit, no reminders go out for that draw and game admins are emailed about the settings. 24-hour time (14:00 = 2pm, 07:00 = 7am).</mat-hint>
        <mat-error data-testid="notification-end-time-error"
                   *ngIf="(notificationsEndTimeControl.dirty || notificationsEndTimeControl.touched) && notificationsEndTimeControl.errors">
          Required format: HH:MM (24-hour time)
        </mat-error>
      </mat-form-field>

      @if (timesOutOfOrder) {
        <p class="red-text margin-top-med" data-testid="notification-times-order-error">{{ timesOutOfOrderMessage }}</p>
      }
    </form>
  </ng-container>

  <ng-container actions>
    <button mat-button color="primary" data-testid="submit-notification-settings-button"
            (click)="submit()">Submit</button>
  </ng-container>
</app-dialog-base>
